import { ChangeDetectionStrategy, Component, ViewEncapsulation, computed, inject, input, model } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { statusIcons } from './assets/status-icons';

export const DS_ALERT_TYPE_ARRAY = ['success', 'error', 'caution', 'info'] as const;
export type DsAlertType = (typeof DS_ALERT_TYPE_ARRAY)[number];

export const DS_ALERT_POLITENESS_ARRAY = ['polite', 'assertive'] as const;
export type DsAlertPoliteness = (typeof DS_ALERT_POLITENESS_ARRAY)[number];

@Component({
    selector: 'ds-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    host: {
        'class': 'ds-alert',
        '[class]': 'hostClass()',
        '[class.ds-alert-inverse]': 'inverse()',
        '[attr.role]': 'role()',
        '[attr.aria-atomic]': '"true"',
    },
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DsAlert {
    private readonly _sanitizer = inject(DomSanitizer);
    public readonly type = input<DsAlertType>('success');
    public readonly inverse = model(false);
    public readonly politeness = input<DsAlertPoliteness>('assertive');

    protected readonly role = computed(() => (this.politeness() === 'assertive' ? 'alert' : 'status'));
    protected readonly svg = computed(() => {
        const rawSvg = statusIcons[this.type()];
        return rawSvg ? this._sanitizer.bypassSecurityTrustHtml(rawSvg) : '';
    });
    protected readonly hostClass = computed(() => `ds-alert-${this.type()}`);
}
